import React from 'react';
import styled from 'styled-components';
import { StepIndicator } from 'components/common/StepIndicator';

interface CreateFlowStepIndicatorProps {
  activeStep: number; // 1-indexed
}

export const CreateFlowStepIndicator = ({ activeStep }: CreateFlowStepIndicatorProps) => {
  return (
    <StepContainer>
      <StepIndicator steps={['Type', 'Creation', 'Attach']} activeStep={activeStep} />
    </StepContainer>
  );
};

const StepContainer = styled.div`
  margin-top: -40px;
  margin-bottom: 24px;
`;
